import React from "react";
import Link from "@amzn/awsui-components-react/polaris/link";
import EllipsisText from "../ellipsisText/EllipsisText";
import CopyIdButton from "./CopyIdButton";
import "../ellipsisText/EllipsisText.css";

/** Width of the Transaction Id column on the list pages: room for the title, the copy button and the first characters of the id. */
export const TRANSACTION_ID_COLUMN_WIDTH = 150;

/** A copy button, then the row's transaction id as a link to its details; the id is cut to the column width and shows in full while hovered. */
export default function TransactionIdLink({transactionId, onFollow}) {
    if (!transactionId) {
        return null;
    }
    return (
        <span className="idCell">
            <CopyIdButton text={transactionId} />
            <Link onFollow={onFollow}>
                <EllipsisText text={transactionId} />
            </Link>
        </span>
    );
}
